
import {string, oneOf, bool} from 'prop-types';
import requiredIf from "react-required-if";
import React from 'react';
import Message from '@sabre/spark-react-core/message';


const MessageAlert = ({
                          animate,
                          ariaLabel,
                          ariaLabelledBy,
                          className,
                          content,
                          title,
                          titleHeadingLevel,
                          status,
                          type,
                          role,
                      }) => {

    return <Message
                animate={animate}
                ariaLabel={ariaLabel}
                ariaLabelledBy={ariaLabelledBy}
                className={className}
                content={content}
                title={title}
                titleHeadingLevel={titleHeadingLevel}
                status={status}
                type={type}
                role={role}
            />;
};

MessageAlert.STATUS = { SUCCESS: 'success', WARNING: 'warning', ERROR: 'error', INFO: 'info' };

MessageAlert.TYPE = { PAGE: 'page', CONTAINER: 'container' };

MessageAlert.ROLES = { ALERT: 'alert', REGION: 'region', STATUS: 'status' };

MessageAlert.propTypes = {
    /** ARIA role */
    role: oneOf(Object.values(MessageAlert.ROLES)).isRequired,

    /** Should the component animate in */
    animate: bool,

    /** Additional CSS classes */
    className: string,

    /** Message text */
    content: string,

    /** Message status */
    status: oneOf(Object.values(MessageAlert.STATUS)).isRequired,

    /** Message Title */
    title: string,

    /** Title Heading Level */
    titleHeadingLevel: oneOf([2, 3, 4, 5, 6, '2', '3', '4', '5', '6']),

    /** Message type */
    type: oneOf(Object.values(MessageAlert.TYPE)).isRequired,

    /**
     * aria-label, required when ARIA role is 'region', but can be substituted by ariaLabelledBy
     */
    ariaLabel: requiredIf(
        string,
        (props) =>
            props['role'] === 'region' && props['ariaLabelledBy'] === undefined
    ),

    /**
     * aria-labelledby, required when ARIA role is 'region', but can be substituted by ariaLabel
     */
    ariaLabelledBy: requiredIf(
        string,
        (props) => props['role'] === 'region' && props['ariaLabel'] === undefined
    ),
};

export default MessageAlert;
